var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-main"},[_c('div',{staticClass:"wp-con clearfix"},[_c('div',{staticClass:"official-left"},[_c('UserBox',{attrs:{"xla":{
          show: 'bulletin_page_show',
          click: 'bulletin_page_user_module_click'
        }}}),_vm._v(" "),_c('ServerList',{attrs:{"xla":{
          show: 'bulletin_page_server_module_show',
          click: 'bulletin_page_server_module_click',
          itemClick: 'bulletin_page_server_item_click'
        }}})],1),_vm._v(" "),_c('div',{staticClass:"official-right"},[_c('div',{staticClass:"content-area notice-list"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"left"},[_vm._v("公告列表")]),_vm._v(" "),_c('TitleRight',{attrs:{"list":[
              '公告列表',
              `${_vm.resType({ res_type: this.$route.query.type })}`
            ]},on:{"title-click":function($event){return _vm.$xlaGamePush('bulletin_page_notice_module_click', {
                click_id: 'bread_crumb'
              })}}})],1),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"item",on:{"click":function($event){_vm.openRoute(`./${item.id}`)
              _vm.$xlaGamePush('bulletin_page_notice_item_click', {
                text: item.title,
                notice_id: item.id
              })}}},[_vm._v("\n            ["+_vm._s(_vm.resType(item))+"]"+_vm._s(item.title)+"\n            "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.convertTime(item)))])])}),_vm._v(" "),_c('Panigition',{attrs:{"page":_vm.pageNum},on:{"change":function($event){_vm.getList($event, _vm.$route.query.type)
              _vm.$xlaGamePush('bulletin_page_notice_module_click', {
                click_id: 'page_change'
              })}}})],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }